export const formatHotelNameWithStars = (hotelName: string, stars: number) => {
  const starsString = stars > 0 ? ` ${'*'.repeat(stars)}` : '';

  return `${hotelName}${starsString}`;
};
